/* ================================================== */
/* CHECK MOBILE DEVICE
/* ================================================== */

function checkMobileDevice() {

	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
		return true;
	}

}